import React, { useContext, useEffect, useState } from 'react'
import './FilterPanel.css'
import { withStyles } from '@material-ui/core/styles'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ProductContext from '@/product/context/product/productContext'
import CustomCommonContext from '../../../context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import { Button, TextField } from '@material-ui/core'
import { mapData } from '@/product/common/components'

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion)

const AccordionSummary = withStyles({
    root: {
        backgroundColor: '#fff',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 50,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary)

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails)

const FilterPanel = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const productCommonContext = useContext(ProductCommonContext)

    const productContext = useContext(ProductContext)
    const { active_sorts, getAllActiveSorts } = productContext
    const { alldata_all_dropdown, allCategory, allbrand, allModel } = customCommonContext
    const { setSearchValue } = productCommonContext
    const [expanded, setExpanded] = React.useState('panel0')
    const [activeSorts, setActiveSorts] = useState({})

    const sortValues = props.sorts
    const [searchText, setSearchText] = useState('')
    const [priceRange, setPriceRange] = useState(
        // formik.values.filters.price.value !== '' ? formik.values.filters.price.value : [],
        [0, 10000],
    )

    useEffect(() => {
        setActiveSorts(active_sorts)
        console.log(active_sorts, 'active_sorts')
    }, [active_sorts])

    const sortCategoryAlphabetical = (a, b) => {
        var nameA = a.display_name.toUpperCase() // ignore upper and lowercase
        var nameB = b.display_name.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
            return -1
        }
        if (nameA > nameB) {
            return 1
        }

        // names must be equal
        return 0
    }
    const sortCategoryAlphabeticalName = (a, b) => {
        var nameA = a.name.toUpperCase() // ignore upper and lowercase
        var nameB = b.name.toUpperCase() // ignore upper and lowercase
        if (nameA < nameB) {
            return -1
        }
        if (nameA > nameB) {
            return 1
        }

        // names must be equal
        return 0
    }

    const filterValues = [
        {
            type: 'number',
            name: 'lot_id',
            placeholder: 'Enter Lot #',
            filter: true,
            label: 'Lot #',
            class: '',
            size: 'small',
        },
        {
            label: 'Category',
            type: 'check',
            name: 'categorytypes',
            options: allCategory
                .filter((main) =>
                    activeSorts?.sorts?.sortcategorytypes?.includes(main.id.toString()),
                )
                .sort(sortCategoryAlphabetical),
            filter: true,
        },
        {
            label: 'Brand',
            type: 'check',
            name: 'brand',
            options: allbrand
                .filter((main) => activeSorts?.sorts?.sortbrand?.includes(main.id.toString()))
                .sort(sortCategoryAlphabetical),
            filter: true,
        },
        {
            label: 'Model',
            type: 'check',
            name: 'model',
            options: allModel
                .filter((main) => activeSorts?.sorts?.sortmodel?.includes(main.id.toString()))
                .sort(sortCategoryAlphabeticalName),
            filter: true,
        },

        {
            label: 'Location',
            type: 'check',
            name: 'locations',
            options:
                (activeSorts?.sorts?.sortlocations &&
                    activeSorts?.sorts?.sortlocations.map((ele) => {
                        return {
                            display_name: ele,
                            id: ele,
                        }
                    })) ||
                [],
            filter: true,
        },
        {
            label: 'Manufacturing Year',
            type: 'check',
            name: 'organisation',
            options:
                (activeSorts?.sorts?.sortorganization &&
                    activeSorts?.sorts?.sortorganization.map((ele) => {
                        return {
                            display_name: ele,
                            id: ele,
                        }
                    })) ||
                [],
            filter: true,
        },
        // {
        //     label: 'Condition',
        //     type: 'check',
        //     name: 'condition',
        //     options: alldata_all_dropdown
        //         .filter((main) => {
        //             if (
        //                 main.level === 0 &&
        //                 main.variable == 'conditiontypeid' &&
        //                 (activeSorts &&
        //                 activeSorts.sorts &&
        //                 activeSorts.sorts.sortdata_all_dropdown &&
        //                 activeSorts.sorts.sortdata_all_dropdown.sortconditionTypeId
        //                     ? activeSorts.sorts.sortdata_all_dropdown.sortconditionTypeId.includes(
        //                           main.id.toString(),
        //                       )
        //                     : true)
        //             ) {
        //                 return true
        //             }
        //         })
        //         .sort(sortCategoryAlphabetical),
        //     filter: true,
        // },
        // {
        //     label: 'Location',
        //     type: 'check',
        //     name: 'agency_address',
        //     options: props.addressOptions.sort(sortCategoryAlphabetical),
        //     filter: true,
        // },
        // {
        //     label: 'Region',
        //     type: 'check',
        //     name: 'region',
        //     options: allCategory
        //         .filter((main) => {
        //             activeSorts && activeSorts.sorts && activeSorts.sorts.sortcategory
        //                 ? activeSorts.sorts.sortcategory.includes(main.id.toString())
        //                 : true
        //         })
        //         .sort(sortCategoryAlphabetical),
        //     filter: true,
        // },

        // {
        //     label: 'Sub Category',
        //     type: 'check',
        //     name: 'subCategory',
        //     options: allCategory
        //         .filter((subcat) => {
        //             if (
        //                 subcat.level === 1 &&
        //                 props.formik &&
        //                 props.formik.values.filters &&
        //                 props.formik.values.filters.category.value &&
        //                 props.formik.values.filters.category.value.length
        //                     ? props.formik.values.filters.category.value.includes(
        //                           subcat.level_id.toString(),
        //                       )
        //                     : false
        //             ) {
        //                 return true
        //             }
        //         })
        //         .sort(sortCategoryAlphabetical),
        //     filter: true,
        // },
        // {
        //     label: 'More Options',
        //     type: 'check',
        //     name: 'subCategory',
        //     options: allCategory
        //         .filter((subcat) => {
        //             if (
        //                 subcat.level === 1 &&
        //                 props.formik &&
        //                 props.formik.values.filters &&
        //                 props.formik.values.filters.subCategory.value &&
        //                 props.formik.values.filters.subCategory.value.length
        //                     ? props.formik.values.filters.subCategory.value.includes(
        //                           subcat.level_id.toString(),
        //                       )
        //                     : false
        //             ) {
        //                 return true
        //             }
        //         })
        //         .sort(sortCategoryAlphabetical),
        //     filter: true,
        // },

        {
            label: 'Price',
            hideTitle: true,
            type: 'radio',
            name: 'price',
            options: [
                { id: 0, description: 'All' },
                { id: 10, description: '$10 & UP' },
                { id: 100, description: '$100 & UP' },
                { id: 500, description: '$500 & UP' },
                { id: 1000, description: '$1000 & UP' },
                { id: 5000, description: '$5000 & UP' },
            ],
            int: 1,
            filter: true,
        },
        {
            label: 'Closing Date',
            type: 'date',
            name: 'closing_date',
            filter: true,
            size: 'small',
            class: '',
            disablePast: window.location.href.includes('sold_items') ? false : true,
            disableFuture: window.location.href.includes('sold_items') ? true : false,
        },
    ]

    function sliderText(value) {
        return `AED ${value}`
    }

    const handleChange = (panel) => (event, newExpanded) => {
        if (panel === expanded) {
            setExpanded(false)
        } else setExpanded(panel)
    }

    // const priceFilter = [
    //     {
    //         type: 'number',
    //         class: 'empPermissions d-flex align-items-center flex-wrap',
    //         name: 'min_price',
    //         placeholder: 'from',
    //         filter: true,
    //         formik: formik,
    //     },
    //     {
    //         type: 'number',
    //         class: 'empPermissions d-flex align-items-center flex-wrap',
    //         name: 'max_price',
    //         placeholder: 'to',
    //         filter: true,
    //         formik: formik,
    //     },
    // ]
    const handleSearchTextChange = () => {
        props.formik.setFieldValue(`filters.searchbar.value`, searchText)
    }
    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchTextChange()
        }
    }

    useEffect(() => {
        setSearchText(props.formik.values.filters.searchbar.value)
    }, [])

    useEffect(() => {
        if (!props.keySearch) {
            return
        }

        const handler = setTimeout(() => {
            handleSearchTextChange()
        }, 500) // adjust delay in ms as needed

        return () => clearTimeout(handler)
    }, [searchText, props.keySearch])

    return (
        <div className="filterPanel">
            <div className="d-flex justify-content-between align-items-center filterTitleCnt">
                <h4 className="fpTitle">{'Refine by'}</h4>
                {props.clearSearch && (
                    <Button
                        id="filter_clear_all"
                        onClick={() => {
                            setSearchText('')
                            props.clearSearch()
                        }}
                        className="filterClear"
                    >
                        {/* <span className="material-icons">cancel</span> */}
                        {'Clear All'}
                    </Button>
                )}
            </div>
            <div className="searchBar">
                <div>
                    <TextField
                        variant="outlined"
                        placeholder=""
                        // value={props.formik.values.search || ''}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onKeyDown={handleSearchKeyDown}
                        InputProps={{
                            endAdornment: props?.keySearch ? (
                                ''
                            ) : (
                                <span
                                    className="material-icons pointer"
                                    onClick={handleSearchTextChange}
                                >
                                    search
                                </span>
                            ),
                        }}
                    />
                </div>
            </div>

            <div className="filterAcc mt-3">
                {filterValues
                    .filter((main) =>
                        !props.searchName ? true : props.searchName.includes(main.name),
                    )
                    .map((data, index) => (
                        <Accordion
                            square
                            key={index}
                            expanded={
                                expanded === `panel${index}`
                                // || formik.values[data.name].length > 0
                            }
                            onChange={handleChange(`panel${index}`)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1d-content"
                                id={`panel${index}d-header`}
                            >
                                <h6 className="accTitle">{data.label}</h6>
                            </AccordionSummary>
                            <AccordionDetails>
                                {/*console.log(data, 'dataaa')*/}
                                {data.options && data.options.length > 0 ? (
                                    <div className="filterCheck d-flex align-items-center flex-wrap">
                                        {mapData({ formik: props.formik, data: [data] })}
                                    </div>
                                ) : data.type === 'number' ? (
                                    <div className="w-100">
                                        {mapData({ formik: props.formik, data: [data] })}
                                    </div>
                                ) : ['date', 'dateWithCustomPicker'].includes(data.type) ? (
                                    <div className="w-100">
                                        {mapData({ formik: props.formik, data: [data] })}
                                    </div>
                                ) : (
                                    <small>{`${'No'} ${data.label} ${'Found'}`}</small>
                                )}
                            </AccordionDetails>
                        </Accordion>
                    ))}
            </div>
        </div>
    )
}
export default FilterPanel
